export default function PageHeader({ eyebrow, title, accent = "" , subtitle, align = "left" }) {
  return (
    <section className="relative pt-36 pb-12 lg:pt-44 lg:pb-16 overflow-hidden bg-grain">
      <div className="absolute inset-0 spotlight-gold opacity-40 pointer-events-none" />
      <div className="absolute top-0 right-1/3 w-[500px] h-[500px] rounded-full bg-inci-blue/10 blur-[140px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold/40 to-transparent" />

      <div
        className={`relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${
          align === "center" ? "text-center" : ""
        }`}
      >
        {eyebrow && (
          <p className="text-gold uppercase tracking-[0.4em] text-xs mb-4">
            {eyebrow}
          </p>
        )}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-7xl font-bold leading-[1.02] text-balance">
          <span className="text-gradient-silver">{title}</span>
          {accent && (
            <span className="text-gradient-gold"> {accent}</span>
          )}
        </h1>
        {subtitle && (
          <p
            className={`mt-6 text-base sm:text-lg text-white/65 leading-relaxed max-w-2xl ${
              align === "center" ? "mx-auto" : ""
            }`}
          >
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}
